import React, { useState, useRef, useEffect } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Box,
  Paper,
  ClickAwayListener
} from '@mui/material';
import { MoreVert, SwapHoriz, Visibility } from '@mui/icons-material';

const DropdownMenuButton = ({ 
  options = [], 
  onOptionClick,
  icon = <MoreVert />,
  buttonColor = "secondary",
  size = "medium"
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  const handleOptionClick = (option) => {
    if (onOptionClick) {
      onOptionClick(option);
    }
    handleClose();
  };

  const handleClickAway = () => {
    if (open) {
      handleClose();
    }
  };

  // Default options if none provided
  // const defaultOptions = [
  //   {
  //     label: "Bridge to Polygon",
  //     icon: <SwapHoriz sx={{ fontSize: '1.2rem' }} />,
  //     action: "bridge"
  //   },
  //   {
  //     label: "View Blockchain Account", 
  //     icon: <Visibility sx={{ fontSize: '1.2rem' }} />,
  //     action: "view"
  //   }
  // ];

  const menuOptions = options;

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Box>
        <IconButton
          ref={buttonRef}
          onClick={handleClick}
          size={size}
          sx={{
            border: '1px solid rgb(162, 162, 162)',
            color: 'black',
            borderRadius: '4px', // Square with slightly rounded corners
            width: '32px',
            height: '32px',
            '&:hover': {
              backgroundColor: 'rgb(200, 200, 200)', // Slightly darker on hover
            },
            '&:focus': {
              backgroundColor: 'rgb(200, 200, 200)',
            }
          }}
        >
          {icon}
        </IconButton>
        
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          PaperProps={{
            sx: {
              mt: 1,
              borderRadius: 2,
              boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
              border: '1px solid rgba(0, 0, 0, 0.05)',
              minWidth: 200,
              '& .MuiMenuItem-root': {
                py: 1.5,
                px: 2,
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                }
              }
            }
          }}
        >
          {menuOptions.map((option, index) => (
            <MenuItem 
              key={index}
              onClick={() => handleOptionClick(option)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
              }}
            >
              <ListItemIcon sx={{ minWidth: 'auto', color: 'text.primary' }}>
                {option.icon}
              </ListItemIcon>
              <ListItemText 
                primary={
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      fontWeight: 500,
                      color: 'text.primary',
                      fontSize: '0.875rem'
                    }}
                  >
                    {option.label}
                  </Typography>
                }
              />
            </MenuItem>
          ))}
        </Menu>
      </Box>
    </ClickAwayListener>
  );
};

export default DropdownMenuButton;
